import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EditHistoryComponent } from './edit-history.component';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';



@NgModule({
  declarations: [
    EditHistoryComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
  ],
  exports: [
    EditHistoryComponent,
  ],providers:[
    TranslatePipe
  ]
})
export class EditHistoryModule { }
